import React from 'react';
import PropTypes from 'prop-types';
import { Mutation, Query } from 'react-apollo';

import { AuthManager } from 'inside-out/managers/authManager';

import * as CREATE_BOOKMARK from './create-bookmark.graphql';
import * as REMOVE_BOOKMARK from './remove-bookmark.graphql';
import * as IS_BOOKMARKED from './is-bookmarked.graphql';

const clickHandler = mutation => e => {
	e.preventDefault();

	mutation();
};

export const Queries = ({ contentId, bookmarkableContent, bookmarkType, children }) => (
	<Query query={IS_BOOKMARKED} variables={{ contentId, userId: AuthManager.sharedInstance.userId }}>
		{({ loading, data }) => {
			return (
				<Mutation
					mutation={CREATE_BOOKMARK}
					variables={{
						userId: data && data.user && data.user.id,
						type: bookmarkType,
						contentId,
						bookmarkableContent,
					}}
					update={(cache, { data: { createBookmark } }) => {
						cache.writeQuery({
							query: IS_BOOKMARKED,
							variables: { contentId, userId: AuthManager.sharedInstance.userId },
							data: {
								user: {
									__typename: 'User',
									id: data.user.id,
									bookmarks: [createBookmark],
								},
							},
						});
					}}
					optimisticResponse={{
						createBookmark: {
							__typename: 'Bookmark',
							id: 'optimistic-bookmark',
							contentId,
							bookmarkableContent,
							type: bookmarkType,
						},
					}}
				>
					{createBookmark => (
						<Mutation
							mutation={REMOVE_BOOKMARK}
							variables={{
								id: data && data.user && Array.isArray(data.user.bookmarks) && data.user.bookmarks.length > 0 && data.user.bookmarks[0].id,
							}}
							update={cache => {
								cache.writeQuery({
									query: IS_BOOKMARKED,
									variables: { contentId, userId: AuthManager.sharedInstance.userId },
									data: {
										user: {
											__typename: 'User',
											id: data.user.id,
											bookmarks: [],
										},
									},
								});
              }}
              optimisticResponse={{
                deleteBookmark: {
                  __typename: 'Bookmark',
                    id: 'optimistic-bookmark',
                },
              }}
						>
							{removeBookmark =>
								children({
									loading,
									data,
									createBookmark: clickHandler(createBookmark),
									removeBookmark: clickHandler(removeBookmark),
								})
							}
						</Mutation>
					)}
				</Mutation>
			);
		}}
	</Query>
);

Queries.propTypes = {
	contentId: PropTypes.string.isRequired,
	children: PropTypes.func.isRequired,
	bookmarkableContent: PropTypes.shape({
		to: PropTypes.string.isRequired,
	}),
	bookmarkType: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/shared/icons/bookmarkIcon/queries.js